import React from 'react';
import { CSS } from '@dnd-kit/utilities';
import { DraggableAttributes } from '@dnd-kit/core';
import { SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities';
import type { Transform } from '@dnd-kit/utilities';
import './DashboardCircleProgressDiagramKpiCard.scss';
import CircleChart from 'src/components/charts/CircleChart/CircleChart';
import { DashboardCircleProgressDiagramKpi } from 'src/services/kpi';
import CardContainer from '../../layouts/CardContainer/CardContainer';

export interface DashboardCircleProgressDiagramKpiCardProps {
  attributes?: DraggableAttributes;
  listeners?: SyntheticListenerMap;
  setNodeRef?: (node: HTMLElement | null) => void;
  transform?: Transform | null;
  transition?: string;
  data: DashboardCircleProgressDiagramKpi;
}

const DashboardCircleProgressDiagramKpiCard: React.FC<DashboardCircleProgressDiagramKpiCardProps> = ({
  attributes,
  listeners,
  setNodeRef,
  transform,
  transition,
  data,
}) => {
  const style = {
    transform: CSS.Transform.toString(transform || null),
    transition,
    touchAction: 'none',
  };

  const score = data.totals === 0 ? 0 : (data.data / data.totals) * 100;
  return (
    <CardContainer
      className="scoreCard surface-elevated"
      ref={setNodeRef}
      style={style}
      label={data.title}
      attributes={attributes}
      listeners={listeners}>
      <div className="flex  justify-center h-[85%] w-full pt-5">
        {/* TODO label? */}
        <CircleChart score={score} label="" />
      </div>
      <p className="score-caption pb-5 pt-6">{/* TODO caption? */}</p>
    </CardContainer>
  );
};

export default DashboardCircleProgressDiagramKpiCard;
